import { getType } from 'typesafe-actions';

import {
    fetchIdeas,
    fetchIdeasError,
    fetchIdeasSuccess,
    IdeasListAction,
    ideasUrlChange,
    increaseFetchIdeasStep,
    initIdeas
} from './actions';
import { IdeasListState } from './typings';

export const getIdeasListInitialState = (): IdeasListState => ({
    ideasList: [],
    progressStep: 0,
    ideasRequestInProgress: false,
    ideasRequestIsFinished: false
});

export function ideasList(state: IdeasListState = getIdeasListInitialState(), action: IdeasListAction): IdeasListState {
    switch (action.type) {
        case getType(fetchIdeasSuccess): {
            return {
                ...state,
                url: action.url,
                ideaId: action.ideaId,
                ideasRequestInProgress: false,
                ideasRequestIsFinished: true,
                ideasList: action.ideasList
            };
        }

        case getType(fetchIdeasError): {
            return {
                ...state,
                hasError: true,
                errorMessage: action.message,
                ideasRequestInProgress: false,
                ideasRequestIsFinished: true
            };
        }

        case getType(increaseFetchIdeasStep): {
            return {
                ...state,
                progressStep: state.progressStep + 1
            };
        }

        case getType(ideasUrlChange): {
            return {
                ...state,
                url: action.url
            };
        }

        case getType(fetchIdeas): {
            return {
                ...state,
                ideasRequestInProgress: true,
                ideasRequestIsFinished: false,
                progressStep: 0,
                hasError: false
            };
        }

        case getType(initIdeas): {
            return {
                ...state,
                ideaId: action.ideaId
            };
        }

        default:
            return state;
    }
}
